import React from 'react';
import {
    Router,
    Switch,
    Route
} from 'react-router-dom';
import { useSelector } from "react-redux";
import history from '../utilities/history';
import Home from '../pages/home'
import Nielsen from '../pages/nielsen';
import EposPage from '../pages/epos';
import UserManagement from '../pages/userManagement';
import UserStatistics from '../pages/userStatistics';
import PageNotFound from '../pages/pageNotFound';

function RouteConfig() {
    const { app_role_home } = useSelector((state) => state.hometab)

    return (
        <Router history={history}>
            {
                <Switch>
                    <Route path="/" exact={true}>
                        <Home />
                    </Route>
                    <Route path="/home" exact={true}>
                        <Home />
                    </Route>
                    <Route path="/nielsen" exact={true}>
                        {app_role_home.includes("Read.AllDatasets") || app_role_home.includes("Tool.Admin") || app_role_home.includes("Read.Nielsen") || !app_role_home.includes("Read.Epos") ? <Nielsen /> : <Home />}
                    </Route>
                    <Route path="/epos" exact={true}>
                        {app_role_home.includes("Read.AllDatasets") || app_role_home.includes("Tool.Admin") || app_role_home.includes("Read.Epos") || !app_role_home.includes("Read.Nielsen") ? <EposPage /> : <Home />}
                    </Route>
                    <Route path="/user-management" exact={true}>
                        {app_role_home.includes("Tool.Admin") ? <UserManagement /> : <Home />}
                    </Route>
                    <Route path="/user-statistics" exact={true}>
                        {app_role_home.includes("Tool.Admin") ? <UserStatistics /> : <Home />}
                    </Route>
                    <Route path="*" >
                        <PageNotFound />
                    </Route>
                </Switch>

            }
        </Router>
    );
}

export default RouteConfig;